import { apiService } from './api';
import type { NotificationHistory, ApiResponse } from '../types';

class NotificationService {
  async getRecentNotifications(params?: {
    limit?: number;
    from?: string;
    to?: string;
  }): Promise<ApiResponse<NotificationHistory[]>> {
    const queryParams = new URLSearchParams();

    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.from) queryParams.append('from', params.from);
    if (params?.to) queryParams.append('to', params.to);

    const query = queryParams.toString();
    const url = query ? `/v1/admin/notification-history/all?${query}` : '/v1/admin/notification-history/all';

    return apiService.get<ApiResponse<NotificationHistory[]>>(url);
  }

  async getNotificationsByLineUserId(lineUserId: string, params?: {
    from?: string;
    to?: string;
    limit?: number;
  }): Promise<ApiResponse<NotificationHistory[]>> {
    const queryParams = new URLSearchParams();
    queryParams.append('lineUserId', lineUserId);

    if (params?.from) queryParams.append('from', params.from);
    if (params?.to) queryParams.append('to', params.to);
    if (params?.limit) queryParams.append('limit', params.limit.toString());

    return apiService.get<ApiResponse<NotificationHistory[]>>(
      `/v1/admin/notification-history?${queryParams.toString()}`
    );
  }
}

export const notificationService = new NotificationService();